import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import get from 'lodash/get';
import { SvgHandler } from '../../svg-handler/svg-handler';
import shortsIcon from '../../../../assets/icons/shorts.svg';
import './shorts-pill.m.css';

export const ShortsPill = () => {
  const dispatch = useDispatch();
  const pageType = useSelector(state => get(state, ['qt', 'pageType'], ''));
  const story = useSelector(state => get(state, ['qt', 'data', 'story'], {}));
  const pbConfig = useSelector(state => get(state, ['qt', 'config', 'pagebuilder-config'], {}));
  const shortsPageEnabled = useSelector(state => get(state, ['qt', 'config', 'pagebuilder-config', 'featureToggle', 'shortsPage'], false));

  const showFloatingButton = get(pbConfig, ['shorts', 'showFloatingButton'], false);
  const floatingButtonText = (get(pbConfig, ['shorts', 'floatingButtonText'], 'Shorts') || 'Shorts');
  const floatingButtonPosition = get(pbConfig, ['shorts', 'floatingButtonPosition'], 'bottom-left');
  const shortsPrefix = (get(pbConfig, ['featureToggle', 'configureShortsRoute'], 'shorts') || 'shorts').replace(/^\//, '');
  if (!showFloatingButton || (pageType === 'shorts-page' || !shortsPageEnabled)) return null;

  const handleClick = () => {
    const storySlug = get(story, ['slug'], '');
    const hasSummary = get(story, ['hasSummary'], false);
    const url = (storySlug && hasSummary)
      ? `/${shortsPrefix}/${storySlug}`
      : `/${shortsPrefix}`;
    global.app.navigateToPage(dispatch, url);
  };

  return (
    <button
      styleName={`shorts-pill shorts-pill--${floatingButtonPosition}`}
      onClick={handleClick}
      aria-label={floatingButtonText}
      data-test-id="shorts-pill"
    >
      <span styleName="shorts-pill-text">
        {floatingButtonText}
      </span>

      <SvgHandler
        xlinkHref={shortsIcon}
        clazzName="shorts-pill-icon"
        width="19"
        height="19"
        viewBox="0 0 19 19"
      />
    </button>
  );
};